import React from 'react'
import { useConfirmDialog, useDbRestore, useError } from '@ztechapps/common.hook'
import { BusyButton } from '@ztechapps/webui.button'
import { ShowIf } from '@ztechapps/webui.util'
import { useDbRestoreContext } from './Context'

export type DbRestoreButtonProps = {
  variant?: React.ComponentProps<typeof BusyButton>['variant']
  /** Set by an app that blocks the button for the user — the reason shows on hover. */
  disabledReason?: string
}

export const DbRestoreButton = ({ variant = 'warning', disabledReason }: DbRestoreButtonProps) => {
  const [onRestore, { loading, error }] = useDbRestore()
  const { enabled, onStarted } = useDbRestoreContext()
  const { confirm } = useConfirmDialog({
    title: 'Restore Database',
    text: 'This replaces the database with the latest production backup and cannot be undone. When it finishes, read the log, then log out to sign in again.',
    buttons: { confirm: { text: 'Restore' } },
  })

  useError(error)

  const onClick = async () => {
    await confirm(async () => {
      const result = await onRestore()
      if (result?.state) onStarted(result)
    })
  }

  return (
    <ShowIf condition={enabled}>
      <BusyButton
        text="Restore Db"
        variant={variant}
        isBusy={loading}
        onClick={onClick}
        disabledReason={disabledReason}
        title="You are NOT in PRODUCTION, so you can restore the database."
      />
    </ShowIf>
  )
}
